import { SPONSORSHIP_ENDPOINTS } from "@/features/sponsorship/config/paths";
import type {
  CreateSponsorshipPayload,
  CurrentCampaignResponse,
  SponsorshipBalance,
  SponsorshipListResponse,
  SponsorshipRedemption,
  SponsorshipRedemptionsResponse,
  SponsorshipShowResponse,
  SponsorshipTermResponse,
} from "@/features/sponsorship/types/sponsorship.type";
import { fetcher } from "@/shared/lib/fetcher.client";

type SponsorshipListParams = {
  "page"?: number
  "limit"?: number
  "q[status_eq]"?: string
  "q[active_eq]"?: boolean
  "q[created_at_gteq]"?: string
  "q[created_at_lteq]"?: string
  "q[s]"?: string
};

export const sponsorshipService = {
  async getSponsorshipRequests(params?: SponsorshipListParams): Promise<SponsorshipListResponse> {
    const response = await fetcher.get<SponsorshipListResponse>(
      SPONSORSHIP_ENDPOINTS.LIST,
      { params },
    );
    return response.data;
  },

  async createSponsorshipRequest(payload: CreateSponsorshipPayload): Promise<SponsorshipShowResponse> {
    const response = await fetcher.post<SponsorshipShowResponse>(
      SPONSORSHIP_ENDPOINTS.CREATE,
      payload,
    );
    return response.data;
  },

  async getCurrentCampaign(): Promise<CurrentCampaignResponse> {
    const response = await fetcher.get<CurrentCampaignResponse>(
      SPONSORSHIP_ENDPOINTS.CURRENT_CAMPAIGN,
    );
    return response.data;
  },

  async getBalance(): Promise<SponsorshipBalance> {
    const response = await fetcher.get<SponsorshipBalance>(SPONSORSHIP_ENDPOINTS.BALANCE);
    return response.data;
  },

  async getRedemptions(page = 1): Promise<SponsorshipRedemptionsResponse> {
    const response = await fetcher.get<SponsorshipRedemptionsResponse>(
      SPONSORSHIP_ENDPOINTS.REDEMPTIONS,
      { params: { page } },
    );
    return response.data;
  },

  // Conversion immédiate et tout-ou-rien : aucun montant n'est envoyé,
  // le serveur convertit la totalité du solde convertible (201) ou répond
  // 422 (code sponsorship_redemption_empty_balance) si le solde est vide.
  async createRedemption(): Promise<SponsorshipRedemption> {
    const response = await fetcher.post<SponsorshipRedemption>(SPONSORSHIP_ENDPOINTS.REDEMPTIONS);
    return response.data;
  },

  async getCurrentTerms(): Promise<SponsorshipTermResponse> {
    const response = await fetcher.get<SponsorshipTermResponse>(SPONSORSHIP_ENDPOINTS.TERMS_CURRENT);
    return response.data;
  },

  async acceptTerms(termId: string): Promise<void> {
    await fetcher.post(SPONSORSHIP_ENDPOINTS.TERMS_ACCEPT(termId));
  },
};
